import mutations from './mutations';
import Cookies from 'js-cookie';
import api from '@/api';
import { setItem, removeItem } from '@/utility/localStorageControl';
import { notification } from 'ant-design-vue';
import { DataService } from '@/config/dataService/dataService';

const addNotificationSuccess = message => {
  notification.success({
    message: message,
  });
};

const addNotificationError = err => {
  notification.error({
    message: err,
  });
};

const state = () => ({
  login: Cookies.get('logedIn'),
  loading: false,
  error: null,
  data: {},
  showPrivacyPopup: false,
  agreePrivacy: false,
});

const actions = {
  async login({ commit }, payload) {
    try {
      commit('loginBegin');

      let postData = {
        email: payload.email,
        password: payload.password,
      };

      api
        .post('login', postData, { headers: { 'Content-Type': 'application/json' } })
        .then(response => {
          const tahun = new Date().getFullYear();
          const bulan = new Date().getMonth() + 1;
          if (response.data.profile.is_first_login) {
            commit('loginSuccessFirst', postData);
            addNotificationSuccess('Login Pertama Kali Berhasil');
          } else if (response.data.is_password_expired) {
            commit('loginSuccessExpiredPassword', postData);
            addNotificationSuccess('Password Anda Sudah Kadaluarsa, Silahkan Buat Password Baru.');
          } else {
            setItem('access_token', response.data.access_token);
            setItem('profile_plnbb', response.data.profile);
            setItem('permissions', response.data.permissions);
            setItem('entitas', response.data.profile.entitas_id);
            setItem('tahun', tahun);
            setItem('bulan', bulan);
            Cookies.set('logedIn', true);
            commit('loginSuccess', true);
            addNotificationSuccess('Login Berhasil');

            if (!response.data.has_agreed_privacy_policy) {
              commit('showPrivacyPopup', true);
              addNotificationSuccess('Silakan menyetujui kebijakan privasi.');
              /* } else {
              commit('loginSuccess', true);
              addNotificationSuccess('Login Berhasil'); */
            }
          }
        })
        .catch(err => {
          commit('loginErr', err);
          addNotificationError(err.response.data.message);
        });
    } catch (err) {
      commit('loginErr', err);
      addNotificationError(err.message);
    }
  },
  async logOut({ commit }) {
    try {
      commit('logoutBegin');
      Cookies.remove('logedIn');
      commit('logoutSuccess', null);
      removeItem('profile_plnbb');
      removeItem('access_token');
      removeItem('entitas');
      removeItem('tahun');
      removeItem('bulan');
    } catch (err) {
      commit('logoutErr', err);
    }
  },
  async createPassword({ commit }, payload) {
    try {
      commit('loginBegin');

      let postData = {
        email: payload.email,
        password: payload.password,
        newPassword: payload.newPassword,
      };

      api
        .post('create-password', postData, { headers: { 'Content-Type': 'application/json' } })
        .then(response => {
          setItem('access_token', response.data.access_token);
          setItem('profile_plnbb', response.data.profile);
          setItem('permissions', response.data.permissions);
          Cookies.set('logedIn', true);
          commit('loginSuccess', true);
          addNotificationSuccess('Login Berhasil');
        })
        .catch(err => {
          commit('loginErr', err);
          addNotificationError(err.response.data.message);
        });
    } catch (err) {
      commit('loginErr', err);
      addNotificationError(err.message);
    }
  },
  async resetPassword({ commit }, payload) {
    try {
      commit('loginBegin');

      let postData = {
        email: payload.email,
      };

      api
        .post('reset-password', postData, { headers: { 'Content-Type': 'application/json' } })
        .then(response => {
          commit('resetPasswordSuccess', true);
          addNotificationSuccess(response.data.message);
        })
        .catch(err => {
          commit('loginErr', err);
          addNotificationError(err.response.data.message);
        });
    } catch (err) {
      commit('loginErr', err);
      addNotificationError(err.message);
    }
  },
  async checkPrivacyPolicy({ commit }, payload) {
    try {
      await DataService.get('check-user-privacy-agreement', payload).then(response => {
        if (response.data.data !== null) {
          commit('checkPrivacyPolicySuccess', true);
        }
      });
    } catch (err) {
      commit('checkPrivacyPolicyErr', err);
    }
  },
  async loginToken({ commit }, token) {
    try {
      commit('loginBegin');

      api
        .post(
          'verify-token',
          { token },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          },
        )
        .then(response => {
          setItem('access_token', response.data.access_token);
          setItem('profile_plnbb', response.data.profile);
          setItem('permissions', response.data.permissions);
          Cookies.set('logedIn', true);
          commit('loginSuccess', true);
          addNotificationSuccess('Login Berhasil');

          if (!response.data.has_agreed_privacy_policy) {
            commit('showPrivacyPopup', true);
            addNotificationSuccess('Silakan menyetujui kebijakan privasi.');
          } else {
            commit('loginSuccess', true);
            addNotificationSuccess('Login Berhasil');
          }
        });
    } catch (err) {
      commit('loginErr', err);
      addNotificationError(err.message);
    }
  },
};

export default {
  namespaced: false,
  state,
  actions,
  mutations,
};
